import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Icons24 } from "../../Icons24Sprite/index.js";
import { IconWrapper } from "../../IconWrapper/index.js";
import { withThemeAndSize } from "../../withThemeAndSize/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import '../../../assets/index51.css';const disclosure = "_disclosure_bw9tt_2";
const infoSection = "_infoSection_bw9tt_31";
const labelWrapper = "_labelWrapper_bw9tt_38";
const label = "_label_bw9tt_38";
const caption = "_caption_bw9tt_61";
const valueSection = "_valueSection_bw9tt_75";
const value = "_value_bw9tt_75";
const icon = "_icon_bw9tt_96";
const s = {
  disclosure,
  infoSection,
  labelWrapper,
  label,
  caption,
  valueSection,
  value,
  icon
};
const Disclosure = withThemeAndSize(
  forwardRef(({ className, leftIcon, label: label2 = null, caption: caption2, value: value2, rightIcon, ...rest }, ref) => /* @__PURE__ */ jsxs("button", { ...rest, type: "button", className: clsx(s.disclosure, className), ref, children: [
    /* @__PURE__ */ jsxs("div", { className: s.infoSection, children: [
      /* @__PURE__ */ jsx(IconWrapper, { className: s.icon, children: leftIcon }),
      /* @__PURE__ */ jsxs("div", { className: s.labelWrapper, children: [
        /* @__PURE__ */ jsx("div", { className: s.label, children: label2 }),
        caption2 && /* @__PURE__ */ jsx("div", { className: s.caption, children: caption2 })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: s.valueSection, children: [
      /* @__PURE__ */ jsx("div", { className: s.value, children: value2 }),
      /* @__PURE__ */ jsx(IconWrapper, { className: s.icon, children: rightIcon || /* @__PURE__ */ jsx(Icons24, { name: "NavRight" }) })
    ] })
  ] }))
);
export {
  Disclosure
};
